<div class="row">
  <div class="col-12 col-lg-6 mb-4">
    <div class="card stretch-card h-100">
      <div class="card-body">
        <h4 class="card-title mb-3">{{'LIVE_VIEW.OCCUPANCY_IN_A_DAY' | translate }}</h4>
        <div class="chart-container">
          <canvas baseChart
                  [type]="charts[0].type"
                  [data]="charts[0].data"
                  [options]="charts[0].options">
          </canvas>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-6">
    <div class="mini-statistics d-flex flex-wrap gap-2">
      <div class="mini-card d-flex align-items-center p-2">
        <i class="mdi mdi-trending-up fs-2 ms-1 me-2"></i>
        <span>
          <p class="mb-1">{{'STATISTICS.PEAK_OCCUPANCY' | translate}}</p>
          <h3 class="mb-1">{{ liveViewChartsData.kpis.peakOccupancy.value }}</h3>
        </span>
      </div>

      <div class="mini-card d-flex align-items-center p-2">
        <div class="chart-container w-100">
          <div class="progress mb-2 fw-bold fs-6 text-white">
            <div class="progress-bar d-flex align-items-center justify-content-center"
                 role="progressbar"
                 [style.width.%]="charts[1].data.newVisitorsPercentage"
                 [style.backgroundColor]="colors.primary"
                 [attr.aria-valuenow]="charts[1].data.newVisitorsPercentage" aria-valuemin="0" aria-valuemax="100">
              {{ charts[1].data.newVisitorsPercentage }}%
            </div>
            <div class="progress-bar d-flex align-items-center justify-content-center"
                 role="progressbar"
                 [style.width.%]="charts[1].data.returningVisitorsPercentage"
                 [style.backgroundColor]="colors.secondary"
                 [attr.aria-valuenow]="charts[1].data.returningVisitorsPercentage" aria-valuemin="0" aria-valuemax="100">
              {{ charts[1].data.returningVisitorsPercentage }}%
            </div>
          </div>

          <div class="flex-grow-1 w-100">
            <div class="d-flex align-items-center mb-1">
              <span class="rounded-circle me-3" [style.backgroundColor]="colors.primary"></span>
              <span class="flex-grow-1">{{ 'LIVE_VIEW.NEW_VISITS' | translate }}</span>
              <span class="fw-bold">{{ charts[1].legendData.newVisitors }}</span>
            </div>
            <div class="d-flex align-items-center mb-1">
              <span class="rounded-circle me-3" [style.backgroundColor]="colors.secondary"></span>
              <span class="flex-grow-1">{{ 'LIVE_VIEW.RETURNING_VISITS' | translate }}</span>
              <span class="fw-bold">{{ charts[1].legendData.returningVisitors }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mini-card d-flex align-items-center p-2">
        <i class="mdi mdi-autorenew fs-2 ms-1 me-2"></i>
        <span>
          <p class="mb-1">{{'STATISTICS.DOMINANT_AGE_GROUP' | translate}}</p>
          <h3 class="mb-1">{{ liveViewChartsData.kpis.dominantAgeGroup['visits']?.label }}</h3>
          <p class="mb-0">{{ liveViewChartsData.kpis.dominantAgeGroup['visits']?.percentage }}% {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
        </span>
      </div>

      <div class="mini-card d-flex align-items-center p-2">
        <i class="mdi mdi-account-multiple fs-2 ms-1 me-2"></i>
        <span>
          <p class="mb-1">{{'STATISTICS.RETURNING_RATE' | translate}}</p>
          <h3 class="mb-1">{{ liveViewChartsData.kpis.returning['visits'].returningCount }}</h3>
          <p class="mb-0">{{ liveViewChartsData.kpis.returning['visits'].rate }}% {{'STATISTICS.VS_PREVIOUS_PERIOD' | translate}}</p>
        </span>
      </div>
    </div>
  </div>
</div>
